module.exports = __webpack_public_path__ + "static/media/folder-active.6b45e4f5.svg";